angular.module('app').component('simSuiteTreeview', {
    bindings: {
        testerId: '<',
        onSelect: '&'
    },
    controllerAs: 'vm',
    controller: function ($location, toastr, $localStorage, SimSuiteTreeviewServiceApi) {
        let vm = this;
        vm.selectNode = selectNode;
        vm.simTraces = simTraces;
        vm.suiteTraces = suiteTraces;
        this.$onInit = function () {
            // Changes handles
            vm.testerId = this.testerId;
        };
        this.$onChanges = function (changes) {
            // Only the testerId will change then we get a new treeview
            if (!changes) {
                return;
            }
            let testerId = changes.testerId.currentValue;
            renderTreeview(testerId);
        };
        function renderTreeview(testerId) {
            SimSuiteTreeviewServiceApi.simSuiteTreeview(testerId).then(function (response) {
                let simSuiteTreeNodes = response.data;
                vm.dataForTheTree = simSuiteTreeNodes;
                // Expand all sims to show suites
                vm.expandedNodes = simSuiteTreeNodes;
                selectFirstOrDefaultSuite(simSuiteTreeNodes);
            });
        }
        function selectFirstOrDefaultSuite(nodes) {
            // Select the node we saved earlier
            let savedNode = $localStorage.simSuiteNode;
            if (angular.isDefined(savedNode)) {
                vm.selectedNode = savedNode;
                vm.onSelect({ node: savedNode });
                return;
            }
            // Or select the first suite
            if (nodes.length > 0) {
                let sim = nodes[0];
                if (sim.children.length > 0) {
                    let suite = sim.children[0];
                    vm.selectedNode = suite;
                    selectNode(suite);
                }
            }
        }
        function selectNode(node) {
            // TODO: Use the SimSuiteNodesService
            // Handle all of the simSuiteNodes
            saveSimSuiteNode(node);
            $localStorage.simSuiteNode = node;
            vm.onSelect({ node: node });
            vm.selectedNode = node;
            // Enable disable suiteTraces button
            vm.suiteTracesDisabled = node.nodeType === SimSuiteNodeType.sim;
        }
        function saveSimSuiteNode(node) {
            let simSuiteNodes = $localStorage.simSuiteNodes;
            if (angular.isUndefined(simSuiteNodes)) {
                // Initialise our list
                simSuiteNodes = [];
            }
            // Can we find the node in the list
            let idx = _.findIndex(simSuiteNodes, function (obj) {
                return (obj.testerId === node.testerId &&
                    obj.simId === node.simId &&
                    obj.suiteId === node.suiteId);
            });
            // If we can't find the node add it to he list
            if (idx === -1) {
                // Add the node to the list
                simSuiteNodes.push(node);
                $localStorage.simSuiteNodes = simSuiteNodes;
            }
        }
        function simTraces(node) {
            let url = `TraceSummary/${node.testerId}/${node.simId}`;
            toastr.info(url);
            $location.path(url);
        }
        function suiteTraces(node) {
            let url = `TraceSummary/${node.testerId}/${node.simId}/${node.suiteId}`;
            toastr.info(url);
            $location.path(url);
        }
        // TODO: Add any other functionality as required
    },
    template: `
<div class="panel panel-primary">
    <div class="panel-heading">
        <div class="panel-title space-bottom">
            <i class="fa fa-user space-right"></i> Simulators and Suites
            <div class="pull-right">
                <span><button class="btn btn-info btn-xs space-left" ng-click="vm.simTraces(vm.selectedNode)">
                    <i class="glyphicon glyphicon-transfer space-right"></i>
                    Simulator Traces
                    <i class="glyphicon glyphicon-random space-left"></i>
                    </button></span>
                <span><button class="btn btn-info btn-xs space-left" ng-disabled="vm.suiteTracesDisabled" ng-click="vm.suiteTraces(vm.selectedNode)">
                    <i class="glyphicon glyphicon-tags space-right"></i>                   
                    Test Suite Traces
                    <i class="glyphicon glyphicon-random space-left"></i>
                    </button></span>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div>
            <treecontrol class="tree-light" tree-model="vm.dataForTheTree" filter-expression="predicate" filter-comparator="comparator"
                options="treeOptions" on-selection="vm.selectNode(node)" expanded-nodes="vm.expandedNodes" selected-node="vm.selectedNode">
                <!-- TODO: Show wether sim is switched on or off -->
                <span ng-switch="" on="node.nodeType">
                    <span ng-switch-when="sim" class="glyphicon glyphicon-transfer text-info space-right" aria-hidden="true"></span>
                <span ng-switch-when="suite" class="glyphicon glyphicon-tags text-info space-right" aria-hidden="true"></span>
                <!--<span ng-switch-when="test" class="glyphicon glyphicon-flash text-info space-right" aria-hidden="true"></span>-->
                </span>
                <span ng-class="{'text-danger': node.nodeType == 'sim' && !node.running, 'text-info': true}">
                    {{node.label}}
                </span>
            </treecontrol>
        </div>
    </div>
</div>    
    `
});
